/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import IDisposable from '../../../lang/IDisposable';
import Disposable from '../../../lang/Disposable';
import {TransformMessageDataType, TransformMessage, TransformMessagePayload, TransformMessageType} from './TransformStreamPipelineWorkerMessage';

export default class TransformPipelineMessageRouter implements IDisposable {
  private readonly _messageRoutes: Map<TransformMessageDataType, <T>(message: T) => void> = new Map();

  constructor(worker: Worker) {
    this.initialize(worker);
  }

  public registerRoute<T>(messageType: TransformMessageDataType, routeMessage: (message: T) => void): Disposable {
    this._messageRoutes.set(messageType, routeMessage as <T>(message: T) => void);

    return new Disposable(() => this._messageRoutes.delete(messageType));
  }

  public dispose(): void {
    this._messageRoutes.clear();
  }

  private initialize(worker: Worker): void {
    worker.addEventListener('message', ({data: message}: MessageEvent<TransformMessage>) => {
      const routeMessageData = <T>({type, data}: TransformMessagePayload<T>) => {
        const routeMessage = this._messageRoutes.get(type);

        if (!routeMessage) {
          return;
        }

        routeMessage(data);
      };

      switch (message.type) {
        case TransformMessageType.Chunk:
        case TransformMessageType.Metadata:
          routeMessageData(message.data);

          break;

        default:
      }
    }, {once: false});
  }
}